import * as luckyDraw from '../services/luckyDraw';

export default {
  namespace: 'luckyDraw',
  state: {},
  effects: {
    //优惠券活动列表
    //优惠券活动列表
    *getDrawList({ payload: { values }, callback }, { call, put }) {
      //日期需要拼上时间
      let { beginDateTime, endDateTime, ...restParam } = values;
      if (beginDateTime) {
        beginDateTime = `${beginDateTime} 00:00:00`;
      }
      if (endDateTime) {
        endDateTime = `${endDateTime} 23:59:59`;
      }
      const response = yield call(luckyDraw.getActivityList, {
        ...restParam,
        beginDateTime,
        endDateTime,
      });
      yield put({
        type: 'save',
        payload: {
          drawList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //终止
    *activityPause({ payload: { values }, callback }, { call }) {
      const response = yield call(luckyDraw.activityPause, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //删除
    *activityDelete({ payload: { values }, callback }, { call }) {
      const response = yield call(luckyDraw.activityDelete, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //修改概率
    *changeHitRate({ payload: { values }, callback }, { call }) {
      const response = yield call(luckyDraw.changeHitRate, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
